import styles from '../../../pages/LeadCapture/ExhibitorLeads/ExhibitorLeads.module.css'

const QualifierItem = ({ index, qualifier }) => {
    return (
        <>
            <li className={styles.liQualifier}> {qualifier.name}</li>
        </>
    );
}

export default QualifierItem;
